import 'bootstrap/dist/css/bootstrap.min.css';

import './App.scss';
import { useEffect, useState, useDebugValue } from "react";
import { selectNewsPosts, } from "./Redux Store/actions";
import { AppDispatch } from "./Redux Store/store";
import { useDispatch, useSelector } from 'react-redux';
import MailchimpFormContainer from "./MailchimpFormContainer";
import MainNavbar from "./MainNavbar";
import IsMobile from "./IsMobile";
// import {fetchNewsPosts, fetchNewsPostsHeaders} from "./Services/NewsPostDataService";
// import { NewsPostData, NewsPostHeaderData } from "./Data Types/NewsPostData";
import { useApi } from "./Constants";
import { IsInDevelopment } from "./Helper Scripts/IsInDevelopment";
import { BrowserRouter, createBrowserRouter, RouterProvider, Route, Routes, Navigate } from "react-router-dom";
import HomeSegment from "./FullPageSegments/HomeSegment";
import GameSegment, { gameIds } from './FullPageSegments/GameSegment';
import { RootState } from './Redux Store/reducers';
import BlawnodeComNewsUploadForm from './ui-components/BlawnodeComNewsUploadForm';
import { FaYoutube, FaItchIo, FaEnvelope, FaDiscord, FaSteam, FaGithub, FaTiktok, FaTwitter, FaBandcamp, FaSoundcloud } from "react-icons/fa";
import { SiBluesky } from "react-icons/si";
import { AiFillInstagram } from "react-icons/ai";
// import BlankSpaceSegment from "./FullPageSegments/BlankSpaceSegment";


const PageNotFoundSegment = () => {
    return <div>
        <h1 style={{ color: "#d95763" }}>HEY. GO BACK.</h1>
        <p>... This page does not exist.</p>
    </div>;
}


const BodySegment = () => {
    return <div className="App-body" id="start">
        <Routes>
            <Route path="/" element={<HomeSegment />} />
            <Route path="/ping" element={<div>Pong!</div>} />
            <Route path="/games/insomniac_moles" element={<GameSegment gameId={gameIds.INSOMNIAC_MOLES} />} />
            <Route path="*" element={<PageNotFoundSegment />} />
        </Routes>
    </div>;
};


const MailingListFooterSegment = () => {
    return <footer id="mailinglist">
        <MailchimpFormContainer />
    </footer>;
};

const TinySocialIcons = () => {
    return <div style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        padding: "10px",
    }}>
        {/* Itch.io */}
        <a href="https://blawnode.itch.io/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <FaItchIo size={16} color="#FA5C5C" />
        </a>

        {/* YouTube */}
        <a href="https://www.youtube.com/@blawnode" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <FaYoutube size={16} color="#FF0000" />
        </a>

        {/* Vertical divider */}
        <div style={{ width: "1px", backgroundColor: "#ccc", height: "20px" }}></div>

        {/* Bluesky */}
        <a href="https://bsky.app/profile/blawnode.bsky.social" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <SiBluesky size={16} color="#0085ff" />
        </a>

        {/* Email */}
        <a href="mailto:blawnode@gmail.com" style={{ textDecoration: "none", color: "inherit" }}>
            <FaEnvelope size={16} color="#EA4335" />
        </a>

        {/* Vertical divider */}
        <div style={{ width: "1px", backgroundColor: "#ccc", height: "20px" }}></div>

        {/* Discord */}
        <a href="" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <FaDiscord size={16} color="#5865F2" />
        </a>

        {/* Steam */}
        <a href="https://store.steampowered.com/curator/45211893" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <FaSteam size={16} color="#b8b8b8" />
        </a>

        {/* GitHub */}
        <a href="https://github.com/blawnode/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <FaGithub size={16} color="#9e9e9e" />
        </a>

        {/* Bandcamp */}
        <a href="https://blawnode.bandcamp.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <FaBandcamp size={16} color="#629aa0" />
        </a>

        {/* Soundcloud */}
        <a href="https://soundcloud.com/blawnode" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <FaSoundcloud size={16} color="#FF5500" />
        </a>

        {/* TikTok */}
        <a href="https://www.tiktok.com/@blawnode" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <FaTiktok size={16} color="#cccccc" />
        </a>

        {/* Instagram */}
        <a href="https://www.instagram.com/blawnode/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <AiFillInstagram size={16} color="#E4405F" />
        </a>

        {/* Twitter */}
        <a href="https://x.com/blawnode" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            <FaTwitter size={16} color="#1DA1F2" />
        </a>
    </div>;
};


const isObject = (val: any) => typeof val === 'object' && val !== null;

const attemptToStringifyJson = (value: any) => isObject(value) ? JSON.stringify(value) : value;


function App() {
    const dispatch: AppDispatch = useDispatch();
    const newsPosts = useSelector((state: RootState) => state.newsPostDatas);  // Accessing the data from Redux store
    const [formInstanceKey, setFormInstanceKey] = useState(0);
    useDebugValue(formInstanceKey, (k) => `formInstanceKey:${k}`);
    const [formStatus, setFormStatus] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

    // Auto-clear the status message after 5 seconds
    useEffect(() => {
        if (!formStatus) return;
        const timeout = setTimeout(() => setFormStatus(null), 5000);
        return () => clearTimeout(timeout);
    }, [formStatus]);

    // If ANY of the useState's below get uncommented, make sure to make a custom hook with useDebugValue() for them!

    // const [serviceNews, setServiceNews] = useState<NewsPostData[] | null>(null);
    // const [serviceNewsHeaders, setServiceNewsHeaders] = useState<NewsPostHeaderData[] | null>(null);
    //const [serviceNewsStringified, setServiceNewsStringified] = useState("unfetched");

    // const [fetchedTest, setFetchedTest] = useState("");

    useEffect(() => {
        /*async function fetchNewsViaService(){
            // const fetchedTestNews = await fetchNewsPosts(useApi);
            // setServiceNews(fetchedTestNews);

            //const fetchedTestNewsStringified = attemptToStringifyJson(fetchedTestNews);
            //setServiceNewsStringified(fetchedTestNewsStringified);
        }*/
        async function fetchNewsHeadersViaService() {
            //const fetchedTestNewsHeaders = await fetchNewsPostsHeaders(true);
            //setServiceNewsHeaders(fetchedTestNewsHeaders);

            dispatch(selectNewsPosts(useApi));
            //setServiceNewsHeaders(newsPostHeaders);

            //const fetchedTestNewsStringified = attemptToStringifyJson(fetchedTestNews);
            //setServiceNewsStringified(fetchedTestNewsStringified);
        }

        fetchNewsHeadersViaService()
            .catch(console.error);
        /*fetchNewsViaService()
            .catch(console.error);*/
        // fetchNewsPostHeaderData();
    }, []);

    /*function fetchNewsPostData(newsId: string): NewsPostData | null {
        return fetchNewsPostRelatedData<NewsPostData>(newsId, serviceNews);
    }*/
    /*async function fetchNewsPostHeaderData() {
        const res = await fetch("https://0lcvhovr0f.execute-api.us-east-1.amazonaws.com/default/DynamoReader");
        const data = await res.json();
        console.log(data);
    }*/
    /*function fetchNewsPostHeaderDataFromLocalFile(newsId: string): NewsPostHeaderData | null {
        return fetchNewsPostRelatedData<NewsPostHeaderData>(newsId, newsPosts);
    }*/

    /*interface objectWithId {
        id: string,
    }*/

    // TODO OPTIONAL: Badly named?
    /*function fetchNewsPostRelatedData<T extends objectWithId>(newsId: string, preFetchedData: T[] | null /*fetchMethod = (useApi: boolean) => T* /): T | null {
        if (preFetchedData === null) {
            return null;
        }
        console.log(preFetchedData.toString());

        let foundNewsPostRelatedData = (preFetchedData as T[]).find(
            newsPostRelatedData => newsPostRelatedData.id == newsId);  // Returns either a NewsPostData, or undefined.
        let returnedNewsPostRelatedData = foundNewsPostRelatedData === undefined ?
            null : foundNewsPostRelatedData;
        return returnedNewsPostRelatedData;
    }*/

    return (
        <BrowserRouter>
            <div className="App">
                {/* <div className="scrolling-background" />;*/  /*Works perfectly! Doesn't blend nicely into which ever section is below.*/}

                {!IsMobile() && <MainNavbar />}

                <BodySegment />

                {IsInDevelopment() &&
                    // If in development build, then show this:
                    <div style={{paddingTop: "10vh",}}>
                        <div style={{ overflowWrap: "break-word", }}>
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "8px",}}>
                                <img src="/Blawnode_Logo_MAX.png" style={{height: "1em",}}/>
                                <u>Development panel (not visible in blawnode.com!):</u>
                                <img src="/Blawnode_Logo_MAX.png" style={{height: "1em",}}/>
                            </div>
                            
                            {/* {(serviceNews != null) && */}
                            {/* <p>{attemptToStringifyJson(fetchNewsPostHeaderDataFromLocalFile("NEWS-TEST_MAXIMAL"))}</p>} */}
                            {(newsPosts != null) &&
                                <>
                                    {/* <p>{attemptToStringifyJson(fetchNewsPostData("NEWS-TEST_MINIMAL"))}</p>} */}
                                    <p>{attemptToStringifyJson(newsPosts.find(post => post.id == "NEWS-TEST_MINIMAL"))}</p>
                                    <p>{attemptToStringifyJson(newsPosts.find(post => post.id == "NEWS-TEST_MAXIMAL"))}</p>
                                </>
                            }
                            {/* {fetchedTest} */}
                            <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", }}>
                                <div className="formWrapper" style={{ width: "50%", height: "100%",
                                    backgroundColor: "#222034",
                                    padding: "16px",
                                    borderRadius: "8px",
                                    display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column",
                                }}>
                                    <BlawnodeComNewsUploadForm
                                        key={formInstanceKey}
                                        overrides={{
                                            thumbnailMetadata: {
                                                accessLevel: ((typeof window !== 'undefined' && window.location?.hostname === 'localhost') ? 'public' : 'private') as any,
                                                onUploadError: (error: any) => {
                                                    console.error('Thumbnail upload failed', error);
                                                },
                                            },
                                            thumbnailUri: {
                                                isReadOnly: true,
                                                placeholder: '',
                                                style: { display: 'none' },
                                            },
                                        }}
                                        onSubmit={(fields: any) => {
                                            // Persist only the S3 key (thumbnailMetadata). Do not store a concrete URL.
                                            // Let the reader/view layer derive a public or signed URL when needed.
                                            fields.thumbnailUri = null; // normalize to null so generated form saves it as null
                                            return fields;
                                        }}
                                        onError={(fields: any, message: string) => {
                                            console.error('BlawnodeComNewsUploadForm save failed', { fields, message });
                                            setFormStatus({ type: 'error', text: 'Upload failed. Please try again.' });
                                        }}
                                        onSuccess={(fields: any) => {
                                            console.log('BlawnodeComNewsUploadForm saved', fields);
                                            // Force a remount so StorageManager clears its internal list
                                            setFormInstanceKey((k) => k + 1);
                                            setFormStatus({ type: 'success', text: 'Upload successful!' });
                                        }}
                                    />  {/* Customize the releaseDate payload? In AWS Amplify Studio, I'm told you can optionally customize the payload before submission using the onSubmit handler. */}
                                    {formStatus && (
                                        <div style={{
                                            marginTop: "12px",
                                            color: formStatus.type === 'success' ? '#7ecb7a' : '#ff6b6b',
                                            fontSize: "0.9rem",
                                        }}>
                                            {formStatus.text}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div style={{
                    width: "100%", height: "20vh",
                    backgroundImage: "linear-gradient(#45283c, #222034)",
                }} />

                <div style={{
                    backgroundColor: "#222034",
                }}>
                    <MailingListFooterSegment />
                    <TinySocialIcons />
                </div>
            </div>
        </BrowserRouter>
    );
}

export default App;
